<style type="text/css">
  .handled  {
    opacity: 0.5;
  }
</style>
<t4-header></t4-header>
<mat-tab-group>
  <mat-tab label="{{ 'turbo.OneWay.CountingDetails.tabDiscrepancies' | translate : 'Discrepancies' }}">
    <t4-container *ngIf="countingId">
      <t4-data-table apiMethod="OneWay/GetCountingDiscrepancies" [parameters]="{ id: countingId }" headline="{{ 'turbo.OneWay.CountingDetails.Headline' | translate : 'OneWay Countings' }}" matSort [autoGenerateColumns]="false" [filterFields]="['CountingLocation.Name', 'SystemLocation.Name', 'RentalObject.Alias']">
        <ng-container matColumnDef="CountingLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.CountingDetails.colLocation' | translate : 'Location' }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><t4-location-link [locationId]="row.CountingLocation.Id" [ngClass]="{ handled: row.IsHandled }">{{row.CountingLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.Alias">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.CountingDetails.colTrailer' | translate : 'Trailer' }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><t4-object-link [objectId]="row.RentalObjectId" [ngClass]="{ handled: row.IsHandled }">{{row.RentalObject.Alias}} ({{row.RentalObject.Title}})</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Result">
          <mat-header-cell *matHeaderCellDef mat-sort-header style=" width:100px;">{{ 'turbo.OneWay.CountingDetails.colResult' | translate : 'Result' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }">
            <mat-icon *ngIf="row.Result == 2" style="color: #dc3545">delete_forever</mat-icon>
            <mat-icon *ngIf="row.Result == 1" style="color: #28a745">location_on</mat-icon>
            <mat-icon *ngIf="row.Result == 3" style="color: #fd7e14">location_off</mat-icon>
            {{ 'Turbo.OneWay.CountingDetails.Result_' + row.Result | translate}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="Id">
          <mat-header-cell *matHeaderCellDef style=" width:100px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }">
            <button mat-mini-fab (click)="approve(row)" *ngIf="!row.IsHandled && row.Result != 2">
              <mat-icon>check</mat-icon>
            </button>&nbsp;
            <button mat-icon-button color="warn" (click)="reject(row)" *ngIf="!row.IsHandled">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="SystemLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.CountingDetails.colExpectedLocation' | translate : 'Expected location' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" [ngClass]="{ handled: row.IsHandled }">{{row.SystemLocation.Name }} ({{ row.SystemLocation.Id}})</mat-cell>
        </ng-container>
      </t4-data-table>
    </t4-container>
  </mat-tab>
  <mat-tab label="{{ 'turbo.OneWay.CountingDetails.tabResults' | translate : 'Results' }}">
    <t4-container *ngIf="countingId">
      <t4-data-table apiMethod="OneWay/GetCountingStatus" [parameters]="{ id: countingId }" headline="{{ 'turbo.OneWay.CountingDetails.Headline' | translate : 'OneWay Counting results' }}" matSort [autoGenerateColumns]="false" [filterFields]="['Location.Name']">
        <ng-container matColumnDef="Location.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.CountingDetails.colLocation' | translate : 'Location' }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><t4-location-link [locationId]="row.Location.Id">{{row.Location.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="IsCompleted">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="width:100px;">{{ 'turbo.OneWay.CountingDetails.colResult' | translate : 'Result' }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-icon *ngIf="!row.IsCompleted" style="color: #dc3545">hourglass_empty</mat-icon>
            <mat-icon *ngIf="row.IsCompleted" style="color: #28a745">playlist_add_check</mat-icon>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="CompletedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'turbo.OneWay.CountingDetails.colCompleted' | translate : 'Completed' }}</mat-header-cell>
          <mat-cell *matCellDef="let row"><div *ngIf="row.IsCompleted">{{ row.CompletedAt | date : 'yyyy-MM-dd hh:mm' }} ({{ row.CompletedBy }})</div></mat-cell>
        </ng-container>
      </t4-data-table>
    </t4-container>
  </mat-tab>
</mat-tab-group>
